import React from "react";
import ColumnChart from "../../../HighCharts/ColumnChart";
import { getTotal } from "./lib/total_calc";
import {
  useTable,
  useSortBy,
  useFilters,
  useGlobalFilter,
  usePagination,
} from "react-table";
import TableView from "../../../../screens/Admin/Releases/components/TableView";
import { useMemo } from "react";
import { GlobalFilter } from "../../../admin/ReleasesAdmin";

const INITIAL_PAGE_SIZE = 25;

function DspAggregation({
  newUsersSalesData,
  loading,
  isAdmin,
  tableClassName = "my-earnings-section-1-table",
}) {
  let singleChartData = newUsersSalesData?.map((dsp) => {
    return [dsp._id, dsp.totalNetPayable];
  });
  let chartData = [{ type: "column", data: singleChartData }];

  // total values calculations
  let totalNewSales = getTotal(newUsersSalesData, "totalNetPayable");
  let totalNewStreams = getTotal(newUsersSalesData, "totalStreams");
  const formatNumber = new Intl.NumberFormat().format;

  if (totalNewSales) totalNewSales = totalNewSales?.toFixed(2);

  const columns = useMemo(
    () =>
      [
        {
          Header: "Store",
          accessor: "_id",
          Cell: ({ value }) => {
            return value;
          },
        },
        {
          Header: "Streams",
          accessor: "totalStreams",
          Cell: ({ value }) => {
            return formatNumber(value ?? 0);
          },
        },
        {
          Header: "Revenue",
          accessor: "totalNetPayable",
          Cell: ({ value }) => {
            return <td title={value || 0}>€ {value?.toFixed(2) ?? 0}</td>;
          },
        },
      ].filter(Boolean),
    [isAdmin]
  );

  const tableInstance = useTable(
    {
      columns,
      data: newUsersSalesData ?? [],
      initialState: {
        pageIndex: 0,
        pageSize: INITIAL_PAGE_SIZE,
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    state: { globalFilter },
    preGlobalFilteredRows,
    setGlobalFilter,
  } = tableInstance;

  return (
    <>
      <ColumnChart
        data={chartData}
        xLabelsType="category"
        xLabelsFormat={undefined}
        yAxisValuePrefix="€ "
      />
      <br />
      <div className={"admin-releases mt-4 pb-3 "}>
        <div className="d-block mb-3" style={{ zIndex: 1 }}>
          <p className="font-weight-bold text-white mb-0">Filter by:</p>
          <div className="row pb-2 align-items-center justify-content-between">
            <div className="col-12 col-md">
              <div className="row">
                <GlobalFilter
                  preGlobalFilteredRows={preGlobalFilteredRows}
                  globalFilter={globalFilter}
                  setGlobalFilter={setGlobalFilter}
                />
              </div>
            </div>
          </div>
        </div>
        <TableView
          tableInstance={tableInstance}
          loading={loading}
          totalNewStreams={totalNewStreams}
          totalNewSales={totalNewSales}
          salesData={true}
        />
      </div>
    </>
  );
}

export default DspAggregation;
